import styled from 'styled-components';
import { BaseSection } from '../components/styles';
import { BaseDivHomePage } from '@/main/components/layouts/homepageLayout/styles';

interface IFirstSectionProps {
  $backgroundImage: string;
}

export const Container = styled(BaseDivHomePage)`
  #id-homepage-about-image-1 {
    object-fit: cover;
    object-position: 69%;

    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
      height: 350px;
    }
  }
  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    padding: 0px;
  }
  #id-homepage-about-image-3 {
    object-fit: cover;
    object-position: 90%;
  }
  #id-homepage-about-image-4 {
    object-fit: cover;
    object-position: 90%;
  }
  #id-homepage-about-image-5 {
    object-fit: cover;
    object-position: 90%;
  }
  #id-homepage-about-image-6 {
    object-fit: cover;
    object-position: 90%;
  }
`;

export const SectionContainer = styled(BaseDivHomePage)`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
`;

export const FirstSection = styled(BaseSection)<IFirstSectionProps>`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: ${({ theme }) => theme.white};
  text-align: center;
  padding-top: 1rem;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-image: url(${props => props.$backgroundImage});
    background-position: left;
    background-size: 570px 380px;
    background-repeat: no-repeat;
    opacity: 0.5; 
    z-index: 1;
    pointer-events: none;
  }


  > button {
    align-items: center;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    max-width: 100%;
    height: auto;

    &::before {
      background-size: 440px;
      background-position-x: -6px;
      background-position-y: 515px;
    }
  }
`;